export enum WalletAvatarType {
    GUN_AVATAR,
    GUN_AVATAR_SQUIRE,
    WALLET_AVATAR,
    WEB_3_AVATAR,
}

export const WALLET_AVATAR_TYPES: WalletAvatarType[] = [
    WalletAvatarType.GUN_AVATAR,
    WalletAvatarType.GUN_AVATAR_SQUIRE,
    WalletAvatarType.WALLET_AVATAR,
    WalletAvatarType.WEB_3_AVATAR
];
